if (!customElements.get('swiper-slideshow')) {
   function debounce(callback, delay) {
      let timer = null;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => {
            callback.apply(this, args);
         }, delay);
      };
   }
   class SwiperSlideshow extends HTMLElement {
      constructor() {
         super();
         if (!this.classList.contains('initialized')) {
            this.classList.add('initialized');
            this.init();
         }
      }

      init() {
         this.settings = this.dataset.settings ? JSON.parse(this.dataset.settings) : {};

         this.handleResponsive();
         window.addEventListener(
            'resize',
            debounce(() => this.handleResponsive(), 100)
         );
      }

      handleResponsive() {
         // Use custom breakpoint or default to 767
         const breakpoint = 750;
         const enableSwiper = window.innerWidth >= breakpoint;

         if (enableSwiper && !this.swiper) {
            this.initSwiper();
         } else if (!enableSwiper && this.swiper) {
            this.destroySwiper();
         }
      }

      initSwiper() {
         const swiperContainer = this.querySelector('.swiper');
         this.swiper = new Swiper(swiperContainer, {
            // watchSlidesProgress: true,
            // virtualTranslate: true,
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 0,
            speed: this.settings.slides_speed || 600,
            mousewheel: {
               releaseOnEdges: true,
               // forceToAxis: true,
               // sensitivity: 1,
            },
            effect: 'fade',
            // fadeEffect: {
            //    crossFade: true,
            // },
         });

         this.setupScrollListener();
         this.setupArrow();

         this.readyTimeout = setTimeout(() => {
            this.classList.add('swiper-ready');
         }, 600);
      }

      destroySwiper() {
         if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
         }

         if (this.readyTimeout) {
            clearTimeout(this.readyTimeout);
            this.readyTimeout = null;
         }

         this.removeScrollListener();
         this.removeArrowListener();
         this.classList.remove('swiper-ready');
      }

      setupScrollListener() {
         const swiperContainer = this.querySelector('.swiper');

         this.wheelHandler = e => {
            const isScrollingUp = e.deltaY < 0;
            const isScrollingDown = e.deltaY > 0;

            // console.log('this.swiper.animating', this.swiper.animating);
            // console.log('this.swiper.isBeginning', this.swiper.isBeginning);
            // console.log('this.swiper.isEnd', this.swiper.isEnd);
            // console.log('-----------');

            // Check if we're transitioning between slides
            if (this.swiper.animating) {
               e.preventDefault();
               e.stopPropagation();
               return;
            }

            // At first slide, scrolling up - allow page scroll
            if (this.swiper.isBeginning && isScrollingUp) {
               return;
            }

            // At last slide, scrolling down - allow page scroll
            if (this.swiper.isEnd && isScrollingDown) {
               return;
            }

            // Otherwise prevent page scroll and let Swiper handle navigation
            e.preventDefault();
            e.stopPropagation();
         };

         swiperContainer.addEventListener('wheel', this.wheelHandler, { passive: false });
      }

      removeScrollListener() {
         const swiperContainer = this.querySelector('.swiper');
         if (this.wheelHandler) {
            swiperContainer.removeEventListener('wheel', this.wheelHandler, { passive: false });
            this.wheelHandler = null;
         }
      }

      setupArrow() {
         this.arrow = this.querySelector('.arrow-ct');
         if (!this.arrow) return;

         // Update arrow position on slide change
         this.swiper.on('slideChange', () => this.updateArrowPosition());

         // Set initial arrow position and fade in
         this.updateArrowPosition();

         // Arrow click handler - navigate next or prev based on position
         this.arrowClickHandler = () => {
            if (this.swiper.isEnd) {
               this.swiper.slidePrev();
            } else {
               this.swiper.slideNext();
            }
         };
         this.arrow.addEventListener('click', this.arrowClickHandler);
      }

      updateArrowPosition() {
         if (!this.arrow || !this.swiper) return;

         // Hide arrow immediately
         this.arrow.classList.remove('arrow-ct--visible');

         // Clear any existing fade timeout
         if (this.arrowFadeTimeout) {
            clearTimeout(this.arrowFadeTimeout);
         }

         // Update position
         if (this.swiper.isEnd) {
            this.arrow.classList.add('arrow-ct--top');
         } else {
            this.arrow.classList.remove('arrow-ct--top');
         }

         // Fade in after 1 second
         this.arrowFadeTimeout = setTimeout(() => {
            this.arrow.classList.add('arrow-ct--visible');
         }, 300);
      }

      removeArrowListener() {
         if (this.arrow && this.arrowClickHandler) {
            this.arrow.removeEventListener('click', this.arrowClickHandler);
            this.arrowClickHandler = null;
         }

         // Clear fade timeout
         if (this.arrowFadeTimeout) {
            clearTimeout(this.arrowFadeTimeout);
            this.arrowFadeTimeout = null;
         }
      }
   }
   customElements.define('swiper-slideshow', SwiperSlideshow);
}
